{
  "app.title": "Конфигуратор регуляторов",

  "disconnected.previouslyConnected": "Ранее подключённые",
  "disconnected.connectionBaudRate": "Скорость соединения",
  "disconnected.connectNewDevice": "Подключить новое устройство",

  "connecting.selectDevice": "Выберите USB-устройство для подключения...",

  "error.tryAgain": "Попробовать снова",
  "error.back": "Назад",

  "connected.status": "Подключено",
  "connected.helpText": "Выберите поле, чтобы увидеть описание",
  "connected.disconnect": "Отключить",
  "connected.exportToFile": "Экспорт в файл",
  "connected.saveToDevice": "Сохранить на устройство",
  "connected.serialPlaceholder": "Отправить команду устройству...",
  "connected.send": "Отправить",

  "alerts.noDevice": "Устройство не подключено",
  "alerts.saveSuccess": "Конфигурация успешно сохранена на устройстве!",
  "alerts.saveFailure": "Не удалось сохранить конфигурацию — не найдена конечная точка с записью.",
  "alerts.saveError": "Ошибка сохранения: {error}",
  "alerts.saving": "Сохранение...",

  "errors.webusbNotSupported": "WebUSB не поддерживается в этом браузере. Пожалуйста, используйте Chrome или Edge.",
  "errors.noDeviceSelected": "USB-устройство не выбрано. Пожалуйста, выберите устройство и попробуйте снова.",
  "errors.permissionDenied": "Доступ запрещён. Убедитесь, что страница обслуживается через HTTPS или localhost.",
  "errors.failedToOpen": "Не удалось открыть USB-устройство: {error}",

  "help.default": "Выберите поле, чтобы увидеть описание"
}
